/// <reference types="@capacitor/cli" />
export class AirshipPluginWrapper {
    constructor(plugin) {
        this.plugin = plugin;
    }
    perform(method, value) {
        return this.plugin.perform({ method: method, value: value }).then(value => {
            return value.value;
        });
    }
    addListener(eventType, listener) {
        return this.plugin.addListener(eventType, listener);
    }
}
//# sourceMappingURL=AirshipPlugin.js.map